import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('payroll_log')
export class PayrollLogs {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("int", {
        name: "employee_id"
    })
    employeeId: number;

    @Column('varchar', {
        name: 'employee_name',
    })
    employeeName: string;

    @Column('varchar', {
        name: 'employee_code',
    })
    employeeCode: string;

    @Column('varchar', {
        name: 'employee_type',
    })
    employeeType: string;

    @Column('varchar', {
        name: 'employee_category',
    })
    employeeCategory: string;

    @Column("int", {
        name: "designation"
    })
    designationId: number;

    @Column("int", {
        name: "department"
    })
    department: number;

    @Column('varchar', {
        name: 'payroll_month',
    })
    payrollMonth: string;

    @Column("int", {
        name: "factory_working_days"
    })
    factoryWorkingDays: number;

    @Column("int", {
        name: "attendance"
    })
    attendance: number;

    @Column("int", {
        name: "basic"
    })
    basic: number;

    @Column("int", {
        name: "hra_amount"
    })
    hraAmount: number;

    @Column("int", {
        name: "edu_amount"
    })
    eduAmount: number;

    @Column("int", {
        name: "medical_amount"
    })
    medicalAmount: number;

    @Column("int", {
        name: "spl_amount"
    })
    splAmount: number;

    @Column("int", {
        name: "conveyance_amount"
    })
    conveyanceAmount: number;

    @Column("int", {
        name: "petrol_Amount"
    })
    petrolAmount: number;

    @Column("int", {
        name: "shoe_amount"
    })
    shoeAmount: number;

    @Column("int", {
        name: "washing_amount"
    })
    washingAmount: number;

    @Column("int", {
        name: "uniform_amount"
    })
    uniformAmount: number;

    @Column("int", {
        name: "helper_amount"
    })
    helperAmount: number;

    @Column("int", {
        name: "production_amount"
    })
    productionAmount: number;

    @Column("int", {
        name: "ta_amount"
    })
    taAmount: number;

    @Column("int", {
        name: "bonus_amount"
    })
    bonusAmount: number;

    @Column("int", {
        name: "gross"
    })
    gross: number;

    @Column("int", {
        name: "incentive_hrs"
    })
    incentiveHrs: number;

    @Column("int", {
        name: "cal_basic"
    })
    calBasic: number;


    @Column("int", {
        name: "cal_hra"
    })
    calHra: number;

    @Column("int", {
        name: "cal_edu"
    })
    calEdu: number;

    @Column("int", {
        name: "cal_medical"
    })
    calMedical: number;

    @Column("int", {
        name: "cal_spl"
    })
    calSpl: number;

    @Column("int", {
        name: "cal_conveyance"
    })
    calConveyance: number;

    @Column("int", {
        name: "cal_petrol"
    })
    calPetrol: number;

    @Column("int", {
        name: "cal_shoe"
    })
    calShoe: number;

    @Column("int", {
        name: "cal_washing"
    })
    calWashing: number;

    @Column("int", {
        name: "cal_uniform"
    })
    calUniform: number;

    @Column("int", {
        name: "cal_helper"
    })
    calHelper: number;

    @Column("int", {
        name: "cal_production"
    })
    calProduction: number;

    @Column("int", {
        name: "cal_ta"
    })
    calTa: number;

    @Column("int", {
        name: "cal_bonus"
    })
    calBonus: number;

    @Column("int", {
        name: "cal_gross"
    })
    calGross: number;

    @Column("int", {
        name: "other_e"
    })
    otherEarnings: number;

    @Column("int", {
        name: "incentive_amount_per_hr"
    })
    incentiveAmountPerHr: number;

    @Column("int", {
        name: "total_incentive_hrs"
    })
    totalIncentiveHr: number;

    @Column("int", {
        name: "incentive_amount"
    })
    incentiveAmount: number;

    @Column("int", {
        name: "total_earnings"
    })
    totalEarnings: number;

    @Column("int", {
        name: "epf_amount"
    })
    epfAmount: number;

    @Column("int", {
        name: "esic_amount"
    })
    esicAmount: number;

    @Column("int", {
        name: "mess_d"
    })
    messAmount: number;

    @Column("int", {
        name: "others_d"
    })
    othersAmount: number;

    @Column("int", {
        name: "tds"
    })
    tds: number;

    @Column("int", {
        name: "professional_tax"
    })
    professionalTax: number;

    @Column("int", {
        name: "total_deductions"
    })
    totalDeductions: number;

    @Column("int", {
        name: "net_salary"
    })
    netSalary: number;


    @Column("boolean", {
        name: "freeze_status"
    })
    freezeStatus: boolean;

    @Column('boolean', {
        name: 'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}